import React from 'react';
import { Grid } from '@material-ui/core';

import Protected from 'components/Protected';
import Title from 'components/typography/Title';
import RecipesList from 'components/recipes/list/RecipesList';
import RecipesListLoading from 'components/recipes/list/RecipesListLoading';

import useMyRecipesPage from './useMyRecipesPage';
import EmptyRecipes from './EmptyRecipes';
import FailedWarning from './FailedWarning';

const MyRecipesPage = () => {
  const {
    recipes,
    isLoading,
    hasFailed,
    hasLoaded,
    loadMyRecipes,
  } = useMyRecipesPage();

  const hasAnyRecipes = recipes.length > 0;

  return (
    <Grid container direction="column">
      <Grid item container>
        <Title>My Recipes</Title>
      </Grid>

      <Grid item container style={{ marginTop: 32 }}>
        <Protected justify="flex-start">
          <Grid item container>
            {hasLoaded && !hasAnyRecipes && <EmptyRecipes></EmptyRecipes>}

            {hasLoaded && hasAnyRecipes && (
              <RecipesList recipes={recipes}></RecipesList>
            )}

            {hasFailed && (
              <FailedWarning
                onTryAgainButtonClick={loadMyRecipes}
              ></FailedWarning>
            )}

            {isLoading && <RecipesListLoading count={4}></RecipesListLoading>}
          </Grid>
        </Protected>
      </Grid>
    </Grid>
  );
};

export default MyRecipesPage;
